import React, { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const WishlistContext = createContext(null);

export const useWishlist = () => {
  const context = useContext(WishlistContext);
  if (!context) return { wishlistIds: [], wishlistCount: 0, isInWishlist: () => false, toggleWishlist: () => {}, fetchWishlist: () => {} };
  return context;
};

export const WishlistProvider = ({ children }) => {
  const { user } = useAuth();
  const [wishlistIds, setWishlistIds] = useState([]);
  const [storeId, setStoreId] = useState(null);

  const fetchWishlist = useCallback(async (sid) => {
    if (!user || !sid) return;
    try {
      const res = await axios.get(`${API_URL}/api/stores/${sid}/wishlist`, { withCredentials: true });
      setWishlistIds(res.data.product_ids || []);
      setStoreId(sid);
    } catch {
      setWishlistIds([]);
    }
  }, [user]);

  const fetchWishlistBySlug = useCallback(async (slug) => {
    if (!user || !slug) return;
    try {
      const res = await axios.get(`${API_URL}/api/s/${slug}/wishlist`, { withCredentials: true });
      setWishlistIds(res.data.product_ids || []);
    } catch {
      setWishlistIds([]);
    }
  }, [user]);

  const toggleWishlist = useCallback(async (sid, productId) => {
    if (!user || !sid || !productId) return false;
    const isIn = wishlistIds.includes(productId);
    try {
      if (isIn) {
        await axios.delete(`${API_URL}/api/stores/${sid}/wishlist/${productId}`, { withCredentials: true });
        setWishlistIds(prev => prev.filter(id => id !== productId));
      } else {
        await axios.post(`${API_URL}/api/stores/${sid}/wishlist`, { product_id: productId }, { withCredentials: true });
        setWishlistIds(prev => [...prev, productId]);
      }
      return !isIn;
    } catch {
      return isIn;
    }
  }, [user, wishlistIds]);

  const isInWishlist = useCallback((productId) => wishlistIds.includes(productId), [wishlistIds]);

  return (
    <WishlistContext.Provider value={{
      wishlistIds,
      wishlistCount: wishlistIds.length,
      isInWishlist,
      toggleWishlist,
      fetchWishlist,
      fetchWishlistBySlug,
      storeId
    }}>
      {children}
    </WishlistContext.Provider>
  );
};
